import React, { Fragment, useEffect, useState } from "react";
import { Flex } from "antd";

import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import BackWithLabel from "@/components/common/BackWithLabel";

import IconSaveVideo from "@/components/icons/IconSaveVideo";
import IconChat from "@/components/icons/IconChat";
import IconBackArrow from "@/components/icons/IconBackArrow";
import IconTaskFillEmpty from "@/components/icons/IconTaskFillEmpty";

import "@/styles/pages/guide/my-students.scss";
import TaskDetails from "@/pages/guide/students/TaskDetails";
import StudentVideos from "@/pages/guide/students/StudentVideos";
import { getStudents } from "@/services/users/getStudents";
import StudentConversation from "@/pages/guide/students/StudentConversation";
import { useSearchParams } from "react-router-dom";

const MyStudents = () => {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [key, setKey] = useState(0);

  // Get values from query parameters
  const studentIdFromQuery = searchParams.get("id");
  const tabFromQuery = searchParams.get("tab");

  const updateQueryParams = (id, tab) => {
    setSearchParams({ id, tab });
    setActiveTab(tab);
  };

  const selectStudent = (student) => {
    setSelectedStudent(student);
  };

  const goBack = () => {
    setSelectedStudent(null);
    setActiveTab(null);
    setSearchParams({});
  };

  const handleTabClick = (student, tabName) => {
    setActiveTab(tabName);
    setKey(key + 1);

    if (student) {
      updateQueryParams(student.id, tabName);
    }
  };

  const fetchStudentsData = () => {
    getStudents()
      .then((res) => {
        setStudents(res);

        if (studentIdFromQuery) {
          const foundStudent = res.find((student) => student.id === studentIdFromQuery);
          if (foundStudent) {
            setSelectedStudent(foundStudent);
            setActiveTab(tabFromQuery || "saveVideo");
          }
        } else if (res.length) {
          setSelectedStudent(res[0]);
          updateQueryParams(res[0].id, "saveVideo");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchStudentsData();
  }, []);

  console.log("Students:", students);
  console.log("Query Params:", { studentIdFromQuery, tabFromQuery });

  return (
    <Fragment>
      <div
        className={
          selectedStudent ? "guide-students-wrapper student-selected" : "guide-students-wrapper"
        }
      >
        <Container>
          <CardComponent>
            <div
              className="full-layout"
              style={{
                "--my-student-cols": students.length === 0 ? "100%" : "35% 65%",
              }}
            >
              <div className="layout-sidebar">
                <div className="back-button">
                  <BackWithLabel label="My Students" path="/dashboard" />
                </div>
                {/* <div className="search-bar">
                                    <div className="search-input">
                                        <Input placeholder="Search Students..." className='body-b4' />
                                        <IconSearch />
                                    </div>
                                </div> */}
                <div className="students">
                  {students.length > 0 ? (
                    <>
                      {students?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className={
                              selectedStudent?.firstName === item.firstName &&
                              selectedStudent?.lastName === item.lastName
                                ? "student active"
                                : "student"
                            }
                            onClick={() => selectStudent(item)}
                          >
                            <Flex justify="space-between">
                              <Flex align="center" gap={8}>
                                <div className="profile-picture">
                                  <img
                                    src={item.profileImgUrl || "/assets/images/defaultProfile.jpeg"}
                                    alt=""
                                  />
                                </div>
                                <div className="body-b1-2">
                                  {item.firstName} {item.lastName}
                                </div>
                              </Flex>
                              <div className="icons">
                                <Flex align="center" gap={8}>
                                  <IconSaveVideo
                                    color={
                                      item?.id === selectedStudent?.id && activeTab === "saveVideo"
                                        ? "#db5800"
                                        : null
                                    }
                                    onClick={() => handleTabClick(item, "saveVideo")}
                                  />
                                  <IconTaskFillEmpty
                                    color={
                                      item.id === selectedStudent?.id && activeTab === "taskDetails"
                                        ? "#db5800"
                                        : "#1c1c2c"
                                    }
                                    onClick={() => handleTabClick(item, "taskDetails")}
                                  />
                                  <IconChat
                                    color={
                                      item.id === selectedStudent?.id && activeTab === "chat"
                                        ? "#db5800"
                                        : null
                                    }
                                    onClick={() => handleTabClick(item, "chat")}
                                  />
                                </Flex>
                              </div>
                            </Flex>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      <div className="student no-students" style={{ height: "100%" }}>
                        <div
                          className="session-outer-card"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            margin: "auto 0",
                          }}
                        >
                          <img src="/assets/images/availbility.png" />
                          <div className="title-h4">No students available</div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {students.length ? (
                <div className="content">
                  <div>
                    <div className="header">
                      <div className="student-info">
                        <div className="content-back-button">
                          <IconBackArrow onClick={goBack} />
                        </div>
                        <div className="profile-picture">
                          <img
                            src={
                              selectedStudent?.profileImgUrl || "/assets/images/defaultProfile.jpeg"
                            }
                            alt=""
                          />
                        </div>
                        <div className="body-b1">
                          {selectedStudent?.firstName} {selectedStudent?.lastName}
                        </div>
                      </div>
                    </div>
                  </div>
                  {selectedStudent ? (
                    <Fragment>
                      {/* Display task details via TaskDetails component */}
                      {activeTab === "taskDetails" && (
                        <TaskDetails student={selectedStudent} onClose={goBack} />
                      )}
                      {activeTab === "saveVideo" && (
                        <StudentVideos student={selectedStudent} onClose={goBack} />
                      )}
                      {activeTab === "chat" && (
                        <StudentConversation student={selectedStudent} key={key} />
                      )}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {/* Any other content you want to show when no student is selected */}
                    </Fragment>
                  )}
                </div>
              ) : null}
            </div>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default MyStudents;
